import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { exchangeImpersonationToken } from '../lib/api';

/** Landing route for the admin's "Login as" flow; the single-use grant becomes a session here. */
export function ImpersonatePage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const token = useRef(params.get('token'));
  const exchanged = useRef(false);

  useEffect(() => {
    if (exchanged.current) return;
    exchanged.current = true;
    if (!token.current) {
      setError('This sign-in link is missing its token.');
      return;
    }
    exchangeImpersonationToken(token.current)
      .then(() => navigate('/', { replace: true }))
      .catch(() => setError('This sign-in link has expired or was already used.'));
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center px-6 text-center">
      <p className={error ? 'text-sm text-destructive' : 'eyebrow animate-pulse'}>
        {error ?? 'Signing in'}
      </p>
    </div>
  );
}
